var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgH3 = function SvgH3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.364 22.217a.888.888 0 0 1-.003-1.275.891.891 0 0 1 1.274.028l.001.001a1.295 1.295 0 0 0 2.121-.406 1.297 1.297 0 0 0-1.195-1.8.89.89 0 0 1-.73-1.4l1.16-1.65.051-.074H21a.89.89 0 0 1 0-1.782h3.75a.89.89 0 0 1 .73 1.402l-1.433 2.047-.03.042.045.025a3.078 3.078 0 1 1-3.698 4.842Zm-4.052-8.045h.047v-3.797a.89.89 0 1 1 1.782 0v9.375a.89.89 0 0 1-1.782 0v-3.797h-6.343v3.797a.89.89 0 0 1-1.782 0v-9.375a.89.89 0 0 1 1.782 0v3.797h6.296Z"
  })));
};
export default SvgH3;